import { useCallback, useEffect, useRef } from 'react';

import { applyStyle } from 'utils';

export const useHandleRef = () => {
  const ref = useRef<HTMLButtonElement | null>(null);
  useEffect(() => {
    if (!ref.current) {
      return;
    }

    const parent = ref.current.closest('a');

    if (parent) {
      applyStyle(parent, '--textBlockHeight', `${Math.ceil(ref.current.getBoundingClientRect().height)}px`);
    }
  }, [ref.current]);

  return useCallback((node: HTMLButtonElement) => {
    if (node) {
      ref.current = node;
    }
  }, []);
};

